"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blur = void 0;
var Blur;
(function (Blur) {
    Blur["S"] = "16px";
    Blur["M"] = "32px";
    Blur["L"] = "48px";
})(Blur || (exports.Blur = Blur = {}));
//# sourceMappingURL=Blur.js.map